import { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf,faEdit, faTimes } from '@fortawesome/free-solid-svg-icons';
import ModalTailwind from '../../components/ModalTailwind';
import HistorialPagos from '../User/HistorialPagos'; // Ajusta la ruta si está en otro lugar
import SeleccionMedico from '../User/SeleccionMedico';


const PerfilUser = () => {

  //USE STATES
  const { user, updateUser } = useAuth();
  const [selectedSection, setSelectedSection] = useState('datos');
  const [editMode, setEditMode] = useState(false);
  const [editModeCorreo, setEditModeCorreo] = useState(false);
  const [editModePassword, setEditModePassword] = useState(false);
  const [devices, setDevices] = useState([]);
  const [newDeviceId, setNewDeviceId] = useState('');
  const [showDeviceForm, setShowDeviceForm] = useState(false);
  const [loadingEmail, setLoadingEmail] = useState(false);
  const [loadingPassword, setLoadingPassword] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalInfo, setModalInfo] = useState({ status: '', mensaje: '' });
  const [errorCorreo, setErrorCorreo] = useState('');
  const [errorPassword, setErrorPassword] = useState('');

  //DATOS
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    nombre: '',
    apellidos: '',
    edad: '',
    cp: '',
    municipio: '',
    estado: '',
    pais: '',
    telefono: '',
    // Campos médicos
    cedula: '',
    especialidad: '',
    clinica: '',
    direccion_clinica: '',
    cv_url: '',
  });

  //DATOS PARA UPDATE DE PASSWORD & CORREO
  const [passwordData, setPasswordData] = useState({
  currentPassword: '',
  newPassword: '',
  confirmPassword: '',
});


  //USE EFECT -------
  useEffect(() => {
    if (!user?.id) return;

    const fetchDatos = async () => {
      try {
        let baseData = {
          correo: user.correo || '',
          nombre: user.nombre || '',
          apellidos: user.apellidos || '',
        };

        if (user.rol === 'doctor') {
          // Si es doctor, solo consulta perfil médico
          const resMedico = await axios.get(`https://www.fancyplus.digital/api/medicos/perfil-medico/${user.id}`);
          baseData = { ...baseData, ...resMedico.data };

        } else {
          // Si es usuario común, consulta datos personales
          const res = await axios.get(`https://www.fancyplus.digital/api/users/datos-personales/${user.id}`);
          baseData = { ...baseData, ...res.data };

          // También consulta dispositivos solo para usuarios normales
          const resDevices = await axios.get(`https://www.fancyplus.digital/api/users/devices/${user.id}`);
          setDevices(resDevices.data || []);
        }

        setFormData(baseData);

      } catch (error) {
        console.error('Error obteniendo datos del perfil:', error);
      }
    };

    fetchDatos();
  }, [user]);
  //FIN USE EFECT


  //FUNCIONES
   //FUNCION UPDATE CORREO
  const handleConfirmEmailChange = async () => {
    setLoadingEmail(true);
    setErrorCorreo('');

    try {
      const response = await axios.post('https://www.fancyplus.digital/api/users/update-email', {
        userId: user.id,
        newEmail: formData.correo,
      });

      setModalInfo({ status: 'ok', mensaje: 'Cambio de correo realizado con éxito.' });
      setShowModal(true);
      setEditModeCorreo(false);
    } catch (error) {
      setErrorCorreo(error.response?.data?.message || 'Error al actualizar correo');
    } finally {
      setLoadingEmail(false);
    }
  };


  //FUNCION UPDATE PASSWORD
  const handleChangePassword = async () => {
    setLoadingPassword(true);
    setErrorPassword('');
    
    try {
      const { currentPassword, newPassword, confirmPassword } = passwordData;

      const response = await axios.post('https://www.fancyplus.digital/api/users/update-password', {
        userId: user.id,
        currentPassword,
        newPassword,
        confirmPassword,
      });

      setModalInfo({ status: 'ok', mensaje: 'Cambio de contraseña realizado con éxito.' });
      setShowModal(true);
      setEditModePassword(false);
      setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
    } catch (error) {
      setErrorPassword(error.response?.data?.message || 'Error al cambiar contraseña');
    } finally {
      setLoadingPassword(false);
    }
  };


  //FUNCION PARA BOTONES ANIMACIONES
  const handleChange = (e) => {
    setErrorCorreo('');
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handlePasswordChange = (e) => {
    setErrorPassword('');
    const { name, value } = e.target;
    setPasswordData(prev => ({ ...prev, [name]: value }));
  };

  //FUNCION PARA ACTULIZAR DATOS PERFIL
  const handleSave = async () => {
    try {
      // Guardar datos según el rol
      if (user.rol === 'doctor') {
        // Solo se actualiza perfil médico y userfp
        await axios.put('https://www.fancyplus.digital/api/medicos/perfil-medico', {
          iduserFP: user.id,
          nombre: formData.nombre,
          apellidos: formData.apellidos,
          edad: formData.edad,
          telefono: formData.telefono,
          cedula: formData.cedula,
          especialidad: formData.especialidad,
          cv_url: formData.cv_url,
          clinica: formData.clinica,
          direccion_clinica: formData.direccion_clinica,
        });
      } else {
        // Usuarios normales: datos personales y userfp
        await axios.put('https://www.fancyplus.digital/api/users/datos-personales', {
          iduserFP: user.id,
          nombre: formData.nombre,
          apellidos: formData.apellidos,
          edad: formData.edad,
          telefono: formData.telefono,
          cp: formData.cp,
          municipio: formData.municipio,
          estado: formData.estado,
          pais: formData.pais,
        });
      }

      // Actualizar contexto
      updateUser({
        nombre: formData.nombre,
        apellidos: formData.apellidos,
      });

      setEditMode(false);
    } catch (error) {
      console.error('Error actualizando:', error?.response?.data || error.message);
    }
  };


  const handleCancel = () => setEditMode(false);

  //FUNCION NUEVO DISPSITIVO USAURIO
  const handleAddDevice = async () => {
    if (!newDeviceId.trim()) return;

    try {
      await axios.post(`https://www.fancyplus.digital/api/users/registerDevice`, {
        iduserFP: user.id,
        deviceId: newDeviceId,
        descripcion: 'playera inteligente'
      });

      setDevices(prev => [...prev, { deviceId: newDeviceId }]);
      setNewDeviceId('');
      setShowDeviceForm(false);
    } catch (err) {
      console.error('Error agregando dispositivo:', err);
    }
  };


  //VISTA
  return (
    <div className="flex h-full min-h-screen m-6 rounded-2xl shadow-2xl">
      {/* Menú lateral */}
      <aside className="w-64 bg-white border-r p-6 rounded-2xl shadow z-10 relative">
        <h2 className="text-xl font-bold mb-6">Mi Perfil</h2>
        <nav className="flex flex-col space-y-2 text-sm">
          <button
            onClick={() => setSelectedSection('datos')}
            className={`text-left px-4 py-2 rounded ${
              selectedSection === 'datos' ? 'bg-blue-500 text-white' : 'hover:bg-gray-100'
            }`}
          >
            Datos personales
          </button>

          <button
            onClick={() => setSelectedSection('credenciales')}
            className={`text-left px-4 py-2 rounded ${
              selectedSection === 'credenciales' ? 'bg-blue-500 text-white' : 'hover:bg-gray-100'
            }`}
          >
            Correo y contraseña
          </button>
            
          {/*
          {user.rol === 'doctor' && (
              <button className="text-left px-4 py-2 rounded bg-gray-200 text-gray-500 cursor-not-allowed"> Pacientes (próximamente) </button> 
          )}
          */}
    
          {user.rol === 'user' && (
            <>
              <button
                onClick={() => setSelectedSection('extra')}
                className={`text-left px-4 py-2 rounded ${
                  selectedSection === 'extra' ? 'bg-blue-500 text-white' : 'hover:bg-gray-100'
                }`}
              >
                Mis Dispositivos
              </button>
              <button
                onClick={() => setSelectedSection('pagos')}
                className={`text-left px-4 py-2 rounded ${
                  selectedSection === 'pagos' ? 'bg-blue-500 text-white' : 'hover:bg-gray-100'
                }`}
              >
                Historial de pagos
              </button>
              <button
                onClick={() => setSelectedSection('SeleccionMedico')}
                className={`text-left px-4 py-2 rounded ${
                  selectedSection === 'SeleccionMedico' ? 'bg-blue-500 text-white' : 'hover:bg-gray-100'
                }`}
              >
                Seleccion Medico
              </button>
            </>
          )}
        </nav>
      </aside>


      {/* Contenido principal */}
      <main className="flex-1 p-8 pl-14 -ml-6 backdrop-blur-md bg-white/30 shadow-md rounded-2xl rounded-tl-none rounded-bl-none z-0 relative">
        {selectedSection === 'datos' && (
          <>
            <div className="flex flex-col items-center mb-8">
              <img
                src="https://cdn-icons-png.flaticon.com/512/3135/3135768.png"
                alt="Foto de perfil"
                className="w-40 h-40 rounded-full object-cover shadow-md mb-4"
              />
              <h1 className="text-3xl font-bold">{`${formData.nombre} ${formData.apellidos}`}</h1>
              {formData.correo && <p>Correo: {formData.correo}</p>}
            </div>

            <div className="mb-8">
              <h2 className="text-xl font-semibold mb-4">Datos Personales</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

              {/* Resto de campos dinámicos */}
              {(user.rol === 'doctor'
                ? ['nombre', 'apellidos', 'edad', 'telefono', 'cedula', 'especialidad', 'clinica', 'direccion_clinica', 'cv_url']
                : ['nombre', 'apellidos', 'edad', 'telefono', 'cp', 'municipio', 'estado', 'pais']
              ).map((field) =>
                field === 'cv_url' && formData[field] ? (
                  <div
                    key={field}
                    className="flex items-center space-x-4 p-4 border rounded-lg shadow-sm bg-white max-w-md mt-4"
                  >
                    <FontAwesomeIcon icon={faFilePdf} className="text-red-600 text-4xl" />
                    <div className="flex flex-col">
                      <p className="text-sm font-semibold text-gray-800">Currículum</p>
                      <a
                        href={`/uploads/cvs/${formData.cv_url}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 underline text-sm hover:text-blue-800"
                      >
                        {formData.cv_url}
                      </a>
                    </div>
                  </div>
                ) : (
                  <div key={field}>
                    <label htmlFor={field} className="block text-sm font-medium text-gray-700 mb-1">
                      {field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, ' ')}
                    </label>
                    <input
                      type="text"
                      name={field}
                      value={formData[field] || ''}
                      onChange={handleChange}
                      disabled={!editMode}
                      className={`block w-full border px-3 py-2 rounded-md ${
                        !editMode ? 'bg-gray-100' : 'bg-white'
                      }`}
                    />
                  </div>
                )
              )}
            </div>


              <div className="mt-4 flex gap-2">
                {!editMode ? (
                  <button
                    onClick={() => setEditMode(true)}
                    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                  >
                    Editar
                  </button>
                ) : (
                  <>
                    <button
                      onClick={handleSave}
                      className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                    >
                      Guardar
                    </button>
                    <button
                      onClick={handleCancel}
                      className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500"
                    >
                      Cancelar
                    </button>
                  </>
                )}
              </div>
            </div>
          </>
        )}

        {selectedSection === 'credenciales' && (
          <div className="max-w-xl mx-auto bg-white p-6 rounded shadow">
            <h2 className="text-2xl font-semibold mb-6">Correo y Contraseña</h2>

            {/* ======== CORREO ======== */}
              <div className="mb-8">
                <div className="flex items-center justify-between mb-2">
                  <label className="block text-sm font-medium text-gray-700">Correo electrónico</label>
                  {!editModeCorreo ? (
                    <FontAwesomeIcon
                      icon={faEdit}
                      className="text-blue-600 cursor-pointer"
                      onClick={() => setEditModeCorreo(true)}
                    />
                  ) : (
                    <FontAwesomeIcon
                      icon={faTimes}
                      className="text-red-600 cursor-pointer"
                      onClick={() => { setEditModeCorreo(false); setErrorCorreo(''); }}
                    />
                  )}
                </div>
                <input
                  type="email"
                  name="correo"
                  value={formData.correo || ''}
                  onChange={handleChange}
                  disabled={!editModeCorreo}
                  className={`block w-full border px-3 py-2 rounded-md ${
                    !editModeCorreo ? 'bg-gray-100' : 'bg-white'
                  }`}
                />
                {editModeCorreo && (
                  <>
                    <p className="text-sm text-gray-600 mt-1">
                      Si cambias tu correo, recibirás un enlace de verificación en la nueva dirección.
                    </p>

                    {/* Mensajes */}
                      {errorCorreo && (
                        <p className="text-red-600 mt-3 text-sm">{errorCorreo}</p>
                      )}

                    <div className="relative inline-block">
                      <button
                        onClick={handleConfirmEmailChange}
                        disabled={loadingEmail}
                        className="mt-3 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50"
                      >
                        Confirmar cambio de correo
                      </button>
                      {loadingEmail && (
                        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-70 rounded">
                          <div className="w-5 h-5 border-4 border-green-600 border-t-transparent rounded-full animate-spin"></div>
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>

            {/* ======== CONTRASEÑA ======== */}
            <div>
              <div className="flex items-center justify-between mb-2">
                <label className="block text-sm font-medium text-gray-700">Contraseña</label>
                {!editModePassword ? (
                  <FontAwesomeIcon
                    icon={faEdit}
                    className="text-blue-600 cursor-pointer"
                    onClick={() => setEditModePassword(true)}
                  />
                ) : (
                  <FontAwesomeIcon
                    icon={faTimes}
                    className="text-red-600 cursor-pointer"
                    onClick={() => { setEditModePassword(false); setErrorPassword(''); }}
                  />
                )}
              </div>

              {/* Actual */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Contraseña actual</label>
                <input
                  type="password"
                  name="currentPassword"
                  value={passwordData.currentPassword}
                  onChange={handlePasswordChange}
                  disabled={!editModePassword}
                  className={`block w-full border px-3 py-2 rounded-md ${
                    !editModePassword ? 'bg-gray-100' : 'bg-white'
                  }`}
                />
              </div>

              {/* Nueva */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Nueva contraseña</label>
                <input
                  type="password"
                  name="newPassword"
                  value={passwordData.newPassword}
                  onChange={handlePasswordChange}
                  disabled={!editModePassword}
                  className={`block w-full border px-3 py-2 rounded-md ${
                    !editModePassword ? 'bg-gray-100' : 'bg-white'
                  }`}
                />
              </div>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700">Confirmar nueva contraseña</label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={passwordData.confirmPassword}
                  onChange={handlePasswordChange}
                  disabled={!editModePassword}
                  className={`block w-full border px-3 py-2 rounded-md ${
                    !editModePassword ? 'bg-gray-100' : 'bg-white'
                  }`}
                />

                {errorPassword && (
                  <p className="text-red-600 mt-2 text-sm">{errorPassword}</p>
                )}

              </div>

              {editModePassword && (
                <div className="relative inline-block">
                  <button
                    onClick={handleChangePassword}
                    disabled={loadingPassword}
                    className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-50"
                  >
                    Cambiar contraseña
                  </button>
                  {loadingPassword && (
                    <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-70 rounded">
                      <div className="w-5 h-5 border-4 border-green-600 border-t-transparent rounded-full animate-spin"></div>
                    </div>
                  )}
                </div>

              )}
            </div>
          </div>
        )}

        {/* 
        {selectedSection === 'extradoc' && user.rol === 'doctor' && <Pacientes />}
        */}

        {selectedSection === 'extra' && (
          <>
            {user.rol === 'doctor' ? (
              <div>
                <h2 className="text-xl font-semibold mb-4">Pacientes</h2>
                <p className="text-gray-600">Aquí podrás ver y gestionar tus pacientes (próximamente).</p>
              </div>
            ) : (
              <>
                <div className="mb-4 flex justify-between items-center">
                  <h2 className="text-xl font-semibold">Mis Dispositivos</h2>
                  <button
                    onClick={() => setShowDeviceForm(!showDeviceForm)}
                    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                  >
                    {showDeviceForm ? 'Cancelar' : 'Agregar Dispositivo'}
                  </button>
                </div>

                {showDeviceForm && (
                  <div className="mb-6 bg-white p-4 rounded shadow">
                    <label className="block mb-2 font-medium">ID del Dispositivo</label>
                    <input
                      type="text"
                      value={newDeviceId}
                      onChange={(e) => setNewDeviceId(e.target.value)}
                      className="w-full border px-3 py-2 rounded mb-4"
                    />
                    <button
                      onClick={handleAddDevice}
                      className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                    >
                      Agregar
                    </button>
                  </div>
                )}

                <table className="w-full bg-white shadow rounded">
                  <thead>
                    <tr className="bg-gray-100 text-left">
                      <th className="p-3">#</th>
                      <th className="p-3">ID del Dispositivo</th>
                      <th className="p-3">Descripción</th>
                    </tr>
                  </thead>
                  <tbody>
                    {devices.map((device, index) => (
                      <tr key={index} className="border-t">
                        <td className="p-3">{index + 1}</td>
                        <td className="p-3">{device.deviceId}</td>
                        <td className="p-3">{device.descripcion}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}
          </>
        )}

        {selectedSection === 'pagos' && user.rol === 'user' && (
          <HistorialPagos />
        )}

        {selectedSection === 'SeleccionMedico' && user.rol === 'user' && (
          <SeleccionMedico />
        )}





        <ModalTailwind
          show={showModal}
          onClose={() => setShowModal(false)}
          title="Éxito"
        >
          <p className="text-gray-700 mb-4">{modalInfo.mensaje}</p>
          <div className="flex justify-end">
            <button
              onClick={() => setShowModal(false)}
              className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
            >
              Aceptar
            </button>
          </div>
        </ModalTailwind>

      </main>
    </div>
  );
};

export default PerfilUser;
